import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { completeEnrollEmployeesTask } from 'core'
import { IchraHraProductTaskIds } from 'core/application/adminDashboard/adminTasks'
import { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import useAdminTasks from 'common/hooks/useAdminTasks'

import { useCommandRequestV2 } from 'common/hooks'
import { ROUTE_PATHS } from 'common/routePaths'

import { Alert } from '../../../../common/components'
import { BenefitDesignStep } from '../../../benefitDetails/design/ichra/DesignStepsMapping'
import AdminTasksSteps from '../../common/adminTaskStep'
import InviteIchraEmployeesModal from '../InviteEmployeesModal'

type QsehraAdminTasksProps = {
  activePlanPeriod: PlanPeriodDto
}

const IchraAdminTasks = ({ activePlanPeriod }: QsehraAdminTasksProps) => {
  const history = useHistory()

  const [tasks, ,] = useAdminTasks([])

  const [inviteEmployeesModalVisible, setInviteEmployeesModalVisible] = useState<boolean>()

  const { sendCommand: sendCompleteTaskQuery, isLoading } = useCommandRequestV2(({}) => completeEnrollEmployeesTask())

  const taskCallbackMapper = new Map<number, () => void>()
  taskCallbackMapper.set(IchraHraProductTaskIds.benefitDesign, () =>
    history.push(`${ROUTE_PATHS.DESIGN_BENEFIT_PATH}/${activePlanPeriod?.id}`),
  )
  taskCallbackMapper.set(IchraHraProductTaskIds.completeProfile, () =>
    history.push(`${ROUTE_PATHS.MANAGE_PEOPLE}/complete-admin-profile`),
  )
  taskCallbackMapper.set(IchraHraProductTaskIds.enrollEmployees, async () => {
    const result = await sendCompleteTaskQuery({})
    result.completed && history.push(`${ROUTE_PATHS.MANAGE_PEOPLE}?fromtask=true`)
  })
  taskCallbackMapper.set(IchraHraProductTaskIds.finalizeBenefit, () => {
    history.push(`${ROUTE_PATHS.LEGAL_DOCUMENTS_SIGN_DOCUMENTS}/${activePlanPeriod.id}`)
  })
  taskCallbackMapper.set(IchraHraProductTaskIds.inviteEmployees, () => setInviteEmployeesModalVisible(true))

  const taskIsLoadingMapper = new Map<number, boolean>()
  taskIsLoadingMapper.set(IchraHraProductTaskIds.enrollEmployees, isLoading)

  return (
    <>
      {activePlanPeriod && (
        <>
          <InviteIchraEmployeesModal
            visible={inviteEmployeesModalVisible}
            benefitStartDate={activePlanPeriod.startDate}
            notificationDate={activePlanPeriod.notificationDate}
            onCancel={() => setInviteEmployeesModalVisible(false)}
            onSendInvite={() => {
              window.location.href = ROUTE_PATHS.ADMIN_DASHBOARD_PATH
            }}
          />
        </>
      )}

      {tasks && (
        <AdminTasksSteps
          tasks={tasks}
          taskIsLoading={(taskId) => taskIsLoadingMapper.get(taskId)}
          onTaskClicked={(taskId) => taskCallbackMapper.get(taskId)()}
          headerAlert={
            activePlanPeriod.benefitDesignStatus === BenefitDesignStatus.Completed && (
              <Alert
                className={'mb-16'}
                message={
                  <>
                    <a
                      onClick={(e) => {
                        history.push(
                          `${ROUTE_PATHS.DESIGN_BENEFIT_PATH}/${activePlanPeriod.id}/${BenefitDesignStep.BenefitStartDate}`,
                        )
                      }}
                      href={'#'}
                    >
                      Click here
                    </a>{' '}
                    if you need to make changes to your benefit design; you can do so before you finalize your
                    notification date
                  </>
                }
                type={'info'}
              />
            )
          }
        />
      )}
    </>
  )
}

export default IchraAdminTasks
